import React from 'react';
import PropTypes from 'prop-types';

const SuggestedItem = ({
  activeRef,
  scrollToRef,
  scrollOnOpen,
  className,
  children,
  handleClick,
}) => (
  <button
    tabIndex="-1"
    type="button"
    onClick={handleClick}
    className={className}
    ref={scrollOnOpen ? scrollToRef : activeRef}
  >
    {children}
  </button>
);

SuggestedItem.propTypes = {
  activeRef: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  handleClick: PropTypes.func,
};

SuggestedItem.defaultProps = {
  activeRef: () => {},
  className: '',
  children: null,
  handleClick: () => {},
};

export default SuggestedItem;
